__turbopack_context__.v({
  "footer": "footer-module-scss-module__ovWska__footer",
  "header": "footer-module-scss-module__ovWska__header",
  "linkCollection": "footer-module-scss-module__ovWska__linkCollection",
});
